// import React, { useEffect, useMemo, useState } from "react";
// import { API } from "../config/api";
// import { get } from "../lib/http";

// export default function CategoryBar({ value = "all", onChange = () => {} }) {
//   const [raw, setRaw] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // categories load
//   useEffect(() => {
//     let alive = true;
//     (async () => {
//       try {
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(API.category.category, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });
//         if (!alive) return;
//         const list = Array.isArray(res?.categories) ? res.categories : [];
//         setRaw(list);
//       } catch (err) {
//         console.error("categoryList error:", err);
//         setRaw([]);
//       } finally {
//         setLoading(false);
//       }
//     })();
//     return () => {
//       alive = false;
//     };
//   }, []);

//   // normalize: string OR object → { id, name, value, icon? }
//   const cats = useMemo(() => {
//     const norm = raw.map((c) => {
//       if (typeof c === "string") {
//         return { id: c, name: c, value: c, icon: "" };
//       }
//       const id = c._id || c.id || c.slug || c.name || c.title;
//       const name = c.name || c.title || c.label || String(id || "Category");
//       const icon = c?.icon || ""; // backend se mila ho to use karenge
//       return { id, name, icon, value: c.slug || c.name || id };
//     });
//     // "All" ko sabse pehle with 📂
//     return [{ id: "all", name: "All", value: "all", icon: "📂" }, ...norm];
//   }, [raw]);

//   return (
//     <section className="bg-white border-b">
//       <div className="mx-auto max-w-7xl px-4 py-3 overflow-x-auto no-scrollbar">
//         <div className="flex gap-2">
//           {loading ? (
//             <div className="text-sm text-slate-500">Loading categories…</div>
//           ) : (
//             cats.map((c) => {
//               const active = String(value) === String(c.value);
//               return (
//                 <button
//                   key={c.id}
//                   onClick={() => onChange(c.value)}
//                   className={
//                     "flex items-center gap-2 whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-all duration-200 border shadow-sm " +
//                     (active
//                       ? "bg-[#FFC107] text-slate-700 border-[#FFC107] hover:bg-[#FFC107] hover:shadow-md"
//                       : "bg-white text-slate-700 border-slate-300 hover:bg-slate-50 hover:shadow-md")
//                   }
//                 >
//                   {c.icon ? <span className="text-lg">{c.icon}</span> : null}
//                   {c.name}
//                 </button>
//               );
//             })
//           )}
//         </div>
//       </div>
//     </section>
//   );
// }

import React, { useEffect, useMemo, useRef, useState } from "react";
import { API } from "../config/api";
import { get } from "../lib/http";

// Helper to map category names to premium 3D-like emoji styles
const getCategoryStyle = (name) => {
  const lower = name.toLowerCase();
  
  // Microsoft Fluent Emoji CDN URLs
  const cdn = "https://raw.githubusercontent.com/microsoft/fluentui-emoji/main/assets";
  
  if (lower.includes("music")) return { 
    emoji: "🎵", 
    image: `${cdn}/Musical%20notes/3D/musical_notes_3d.png`,
    glowColor: "rgba(96, 165, 250, 0.55)" // blue
  };
  if (lower.includes("nightlife") || lower.includes("club")) return { 
    emoji: "🪩", 
    image: `${cdn}/Mirror%20ball/3D/mirror_ball_3d.png`,
    glowColor: "rgba(192, 132, 252, 0.55)" // purple
  };
  if (lower.includes("comedy")) return { 
    emoji: "🎤", 
    image: `${cdn}/Microphone/3D/microphone_3d.png`,
    glowColor: "rgba(251, 191, 36, 0.55)" // amber
  };
  if (lower.includes("sport")) return { 
    emoji: "🏆", 
    image: `${cdn}/Trophy/3D/trophy_3d.png`,
    glowColor: "rgba(251, 146, 60, 0.55)" // orange
  };
  if (lower.includes("theatre") || lower.includes("drama")) return { 
    emoji: "🎭", 
    image: `${cdn}/Performing%20arts/3D/performing_arts_3d.png`,
    glowColor: "rgba(251, 113, 133, 0.55)" // rose
  };
  if (lower.includes("dance")) return { 
    emoji: "💃", 
    image: `${cdn}/Woman%20dancing/3D/woman_dancing_3d.png`,
    glowColor: "rgba(244, 114, 182, 0.55)" // pink
  };
  if (lower.includes("food") || lower.includes("drink")) return { 
    emoji: "🍷", 
    image: `${cdn}/Wine%20glass/3D/wine_glass_3d.png`,
    glowColor: "rgba(248, 113, 113, 0.55)" // red
  };
  if (lower.includes("exhibition") || lower.includes("art")) return { 
    emoji: "🖼️", 
    image: `${cdn}/Framed%20picture/3D/framed_picture_3d.png`,
    glowColor: "rgba(52, 211, 153, 0.55)" // emerald
  };
  if (lower.includes("festival")) return { 
    emoji: "🎉", 
    image: `${cdn}/Party%20popper/3D/party_popper_3d.png`,
    glowColor: "rgba(232, 121, 249, 0.55)" // fuchsia
  };
  if (lower.includes("conference") || lower.includes("business")) return { 
    emoji: "👔", 
    image: `${cdn}/Briefcase/3D/briefcase_3d.png`,
    glowColor: "rgba(148, 163, 184, 0.55)" // slate
  };
  if (lower.includes("workshop") || lower.includes("class")) return { 
    emoji: "🛠️", 
    image: `${cdn}/Hammer%20and%20wrench/3D/hammer_and_wrench_3d.png`,
    glowColor: "rgba(168, 162, 158, 0.55)" // stone
  };
  if (lower.includes("all")) return { 
    emoji: "✨", 
    image: `${cdn}/Sparkles/3D/sparkles_3d.png`,
    glowColor: "rgba(250, 204, 21, 0.55)" // yellow
  };
  return { 
    emoji: "🎫", 
    image: `${cdn}/Ticket/3D/ticket_3d.png`,
    glowColor: "rgba(129, 140, 248, 0.55)" // indigo
  }; 
};

export default function CategoryBar({ value = "all", onChange = () => {} }) {
  const [raw, setRaw] = useState([]);
  const [loading, setLoading] = useState(true);
  const wrapRef = useRef(null);
  const [hasLeft, setHasLeft] = useState(false);
  const [hasRight, setHasRight] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
        const res = await get(API.category.category, {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": "application/json",
          },
        });
        if (!alive) return;
        const list = Array.isArray(res?.categories) ? res.categories : [];
        setRaw(list);
      } catch (err) {
        console.error("categoryList error:", err);
        setRaw([]);
      } finally {
        setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  const cats = useMemo(() => {
    const norm = raw.map((c) => {
      if (typeof c === "string") {
        return { id: c, name: c, value: c, icon: c.icon || "" };
      }
      const id = c._id || c.id || c.slug || c.name || c.title;
      const name = c.name || c.title || c.label || String(id || "Category");
      return { id, name, value: c.slug || c.name || id, icon: c.icon || "" };
    });
    return [{ id: "all", name: "All", value: "all", icon: "✨" }, ...norm];
  }, [raw]);

  const updateShadows = () => {
    const el = wrapRef.current;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    setHasLeft(scrollLeft > 0);
    setHasRight(scrollLeft + clientWidth < scrollWidth - 1);
  };

  useEffect(() => {
    updateShadows();
    const el = wrapRef.current;
    if (!el) return;
    const on = () => updateShadows();
    el.addEventListener("scroll", on, { passive: true });
    window.addEventListener("resize", on);
    return () => {
      el.removeEventListener("scroll", on);
      window.removeEventListener("resize", on);
    };
  }, [loading, cats.length]);

  return (
    <section className="dark:bg-slate-950 pt-4 md:pt-8 pb-0 md:pb-4 font-sans transition-colors">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <h2 className="mb-3 md:mb-6 text-2xl font-bold tracking-tight text-slate-900 dark:text-white md:text-3xl transition-colors">
          Explore Events
        </h2>
        
        <div className="relative -mx-4 md:-mx-8">
          <div
            ref={wrapRef}
            className="flex gap-2 overflow-x-auto no-scrollbar scroll-smooth snap-x snap-mandatory pb-1 pt-1 md:pb-8 md:pt-4 px-4 md:px-8 scroll-pl-4 md:scroll-pl-8"
          >
            {loading ? (
              <SkeletonRow />
            ) : (
              cats.map((c) => {
                const active = String(value) === String(c.value);
                const style = getCategoryStyle(c.name);
                
                return (
                  <CategoryCard key={c.id} c={c} active={active} style={style} onChange={onChange} />
                );
              })
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

// Separated component to manage Image Fallback state and completely avoid Safari clipping bugs
function CategoryCard({ c, active, style, onChange }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="py-2 px-2 shrink-0 snap-start">
      <div 
        className={`group relative rounded-full md:rounded-[24px] transition-all duration-300 hover:-translate-y-1 hover:shadow-xl bg-white dark:bg-slate-900 ${
          active ? "ring-2 ring-slate-900 dark:ring-white/30 shadow-md" : "shadow-sm"
        }`}
      >
        <button
          onClick={() => onChange(c.value)}
          className="relative flex h-[52px] md:h-[180px] w-auto md:w-[130px] flex-row-reverse md:flex-col items-center justify-center md:justify-start rounded-full md:rounded-[24px] border border-slate-100 dark:border-white/10 bg-white dark:bg-slate-900 px-4 md:px-0 py-0 md:py-5 outline-none focus:outline-none transition-colors gap-2 md:gap-0"
        >
          {/* 100% Bug-Free Background Glow: Uses a radial-gradient background that natively curves with the rounded border. No blur filters, no bleeding! */}
          <div 
            className="absolute inset-0 rounded-full md:rounded-[24px] pointer-events-none transition-opacity duration-500 opacity-40 group-hover:opacity-70"
            style={{ background: `radial-gradient(130px circle at bottom left, ${style.glowColor}, transparent)` }}
          ></div>
          
          {/* Title */}
          <span className="relative z-10 text-[14px] md:text-[15px] font-bold text-slate-800 dark:text-slate-200 leading-tight whitespace-nowrap md:whitespace-normal md:px-2 text-center md:mb-auto transition-colors">
            {c.name}
          </span>
          
          {/* 3D Icon Image or Emoji Fallback */}
          <div className="relative z-10 md:mt-auto flex items-center md:items-end justify-center w-auto md:w-full h-auto md:h-[80px] transform transition-transform duration-500 group-hover:scale-110 group-hover:-translate-y-1 md:group-hover:-translate-y-2 pointer-events-none">
            {!imgError ? (
              <img 
                src={style.image} 
                alt={c.name}
                className="w-8 h-8 md:w-20 md:h-20 object-contain drop-shadow-xl"
                onError={() => setImgError(true)}
              />
            ) : (
              <div className="text-2xl md:text-6xl drop-shadow-xl" style={{ textShadow: "0px 10px 20px rgba(0,0,0,0.15)" }}>
                {style.emoji}
              </div>
            )}
          </div>
        </button>
      </div>
    </div>
  );
}

function SkeletonRow() {
  const items = Array.from({ length: 8 });
  return (
    <div className="flex gap-2 w-full">
      {items.map((_, i) => (
        <div key={i} className="py-2 px-2 shrink-0">
          <div
            className="h-[52px] w-[100px] rounded-full bg-slate-100 dark:bg-slate-800 md:h-[180px] md:w-[130px] md:rounded-[24px] overflow-hidden relative shadow-sm transition-colors"
          >
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/60 dark:via-slate-700/60 to-transparent" />
          </div>
        </div>
      ))}
      <style>{`
        @keyframes shimmer {
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}
